import * as React from 'react';
import AuthContext from 'Context/AuthContext';
import IfNotTrueModal from '../IfNotTrueModal';
import { Button, Typography } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { SpacedSpan } from './IfNotLoggedInModal.Styled';
import DetailsData from 'Core/models/DetailsData';
import DetailsMode from 'Core/models/DetailsMode';
import Utility from '../../../Core/Utility';
import { Operations } from '../../../Core/Api/Api';
export interface Props extends RouteComponentProps {
    children?: React.ReactNode;
    offeringId?: string;
    sharepoolId?: string;
}

export interface State {
  LoggedIn: boolean;
  contextData?: any;
}

export class IfNotLoggedInModalWithoutRouter extends React.Component<Props, State> {
  static contextType = AuthContext;
  context!: React.ContextType<typeof AuthContext>;

  constructor(props: Props) {
    super(props);

    this.state = {
      LoggedIn: false,
    };
  }

    componentDidMount() {

        this.setState({ contextData: this.context.data, LoggedIn: (!!this.context.data && !Utility.HasOperations(this.context.data, [Operations.Guest_Login])) });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.contextData != this.context.data) {
      // person not logged in
        if (!this.context.data || Utility.HasOperations(this.context.data, [Operations.Guest_Login])) {
        this.setState({ LoggedIn: false, contextData: this.context.data });
      } else {
        this.setState({ LoggedIn: true, contextData: this.context.data });
      }
    }
  }

  SendToRegister = () => {
    this.props.history.push('/register');
  };

  SendToLogin = () => {
    this.props.history.push('/login');
    };

    SendToGuest = () => {
        this.props.history.push('/guest-register', new DetailsData(DetailsMode.New, this.props.offeringId, this.props.sharepoolId ));

    };
        //generalApplyClicked(offeringId, sharePoolId) {
        //    this.props.history.push(
        //        `/ipo/apply/${offeringId}?sp=${sharePoolId}`,
        //        new DetailsData(DetailsMode.New, offeringId)
        //    );

        //};
    //       {/*cancelText="Close"*/ }

  actions = [
      <Button onClick={this.SendToGuest}>Apply As Guest</Button>,
      <Button onClick={this.SendToGuest}>Resume</Button>,
    <Button onClick={this.SendToLogin}>Log In</Button>,
    <Button type="primary" onClick={this.SendToRegister}>
      Sign Up
    </Button>,
  ];

  render() {
    return (
      <IfNotTrueModal
        showCancel={false}
        title={<Typography.Title level={3}>Let's Get You Started</Typography.Title>}
        message={
          <SpacedSpan>
                In order to apply you can:
                <ul>
                    <li>Apply as guest,</li>
                    <li>Login with an account,</li>
                    <li>Or you can register for an account.</li>
                </ul>                              
          </SpacedSpan>
        }
        condition={this.state.LoggedIn}
        actions={this.actions}>
        {this.props.children}
      </IfNotTrueModal>
    );
  }
}

const IfNotLoggedInModal = withRouter(IfNotLoggedInModalWithoutRouter);

export default IfNotLoggedInModal;
